import { CompanyAPI } from '@api';

const removeBus = (busId, reason) => CompanyAPI.removeBus({ busId, reason })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { removeBus };
